import React, { memo } from 'react';
import { BrainIcon, AppleIcon, MoonIcon, WindIcon, CalendarIcon } from 'lucide-react';
export function MethodSection() {
  const pillars = [{
    icon: BrainIcon,
    label: 'Allenamento cognitivo guidato'
  }, {
    icon: AppleIcon,
    label: 'Nutrizione mediterranea'
  }, {
    icon: MoonIcon,
    label: 'Sonno rigenerante'
  }, {
    icon: WindIcon,
    label: 'Mindfulness e respiro'
  }, {
    icon: CalendarIcon,
    label: 'Piano progressivo'
  }];
  return <section className="w-full bg-gray-50 py-20 px-4 sm:px-6 lg:px-8" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center" data-id="element-104">
          Il Metodo VitaCognitiva – Scienza, Allenamento e Serenità Mentale
        </h2>
        <div className="space-y-6 text-lg sm:text-xl text-gray-700 mb-12 max-w-3xl mx-auto" data-id="element-105">
          <p data-id="element-106">
            Il Metodo VitaCognitiva nasce dall'unione tra neuroscienze e vita
            reale. È stato sviluppato insieme a specialisti europei in
            neuroscienze cognitive e neuropsicologia dell'invecchiamento,
            partendo da una domanda semplice: "Perché alcune persone mantengono
            una mente lucida anche oltre i 70 anni, mentre altre iniziano a
            dimenticare già a 55?"
          </p>
          <p data-id="element-107">
            Le risposte arrivano dalla neuroplasticità, la capacità del cervello
            di creare nuove connessioni ogni giorno. Studi condotti dall'INSERM
            in Francia, dall'Università di Bologna e da ricerche internazionali
            (Harvard Medical School, 2019) dimostrano che anche dopo i 60 anni
            il cervello può ricablarsi attraverso esercizi mirati, alimentazione
            equilibrata e gestione dello stress.
          </p>
          <p className="font-semibold" data-id="element-108">
            Il Metodo VitaCognitiva applica queste scoperte in modo pratico:
          </p>
          <ul className="space-y-3 pl-6" data-id="element-109">
            <li className="list-disc" data-id="element-110">
              <strong data-id="element-111">Allenamento mentale quotidiano</strong>, per stimolare
              memoria, attenzione e linguaggio.
            </li>
            <li className="list-disc" data-id="element-112">
              <strong data-id="element-113">Nutrizione mediterranea per il cervello</strong>, con
              alimenti ricchi di omega-3, polifenoli e antiossidanti.
            </li>
            <li className="list-disc" data-id="element-114">
              <strong data-id="element-115">Rituali di benessere</strong> che migliorano il sonno,
              riducono l'ansia e favoriscono la concentrazione.
            </li>
            <li className="list-disc" data-id="element-116">
              <strong data-id="element-117">Piano progressivo di 8 settimane</strong>, per costruire
              abitudini che durano nel tempo.
            </li>
          </ul>
          <p data-id="element-118">
            Bastano 10–15 minuti al giorno per attivare i circuiti della memoria
            e restituire energia mentale, equilibrio e fiducia. Non è un insieme
            di tecniche: è un percorso strutturato, che traduce la scienza in
            risultati quotidiani.
          </p>
          <p className="font-semibold italic" data-id="element-119">
            Perché la mente, proprio come un muscolo, non perde forza con l'età:
            ha solo bisogno di essere allenata nel modo giusto.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mb-12" data-id="element-120">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 text-center hover:shadow-md transition-shadow" data-id="element-121">
                <Icon className="w-12 h-12 mx-auto mb-4 text-green-600" data-id="element-122" />
                <p className="text-base font-medium text-gray-900" data-id="element-123">
                  {pillar.label}
                </p>
              </div>;
        })}
        </div>
        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg" data-id="element-124">
          <p className="text-base sm:text-lg text-gray-700 italic" data-id="element-125">
            Non facciamo promesse mediche: offriamo un percorso strutturato
            basato su evidenze di benessere cognitivo.
          </p>
        </div>
      </div>
    </section>;
}